import { render, staticRenderFns } from "./RegistryCommands.vue?vue&type=template&id=67dec9d3&scoped=true&"
import script from "./RegistryCommands.vue?vue&type=script&lang=js&"
export * from "./RegistryCommands.vue?vue&type=script&lang=js&"
import style0 from "./RegistryCommands.vue?vue&type=style&index=0&id=67dec9d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dec9d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
